import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {currentUserDetail} from '@app/4dm1n/users-list/store/users-list.selector';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {IInbeUser} from '@app/4dm1n/users-list/store/_model';
import {environment} from '@environments/environment';
import {UsersListService} from '@app/4dm1n/users-list/users-list.service';
import {ISelectedPublicationEvent} from '@app/components/_common/publication-selector/ISelectedPublicationEvent';

@Component({
  selector: 'app-publication-links-tab',
  templateUrl: './publication-links-tab.component.html',
  styleUrls: ['./publication-links-tab.component.scss']
})
export class PublicationLinksTabComponent extends OnDestroyMixin implements OnInit {
  private BASE_URL = environment.apiUrl;

  currentUser$: Observable<IInbeUser> = this.store.select(currentUserDetail).pipe(untilComponentDestroyed(this));

  selectedPublication: string = null;
  modeTestSelected = new UntypedFormControl(false);

  constructor(
    private store: Store<AppState>,
    private formBuilder: UntypedFormBuilder,
    private usersListService: UsersListService,
  ) {
    super();
  }


  //
  // Génère une URL direct!
  //

  getUrl(userToken: string, pubUuid: string = null, v2 = false): string {
    const params = [];
    params.push(
      {
        key: 'pubUuid', value: pubUuid
      }
    );
    if (this.modeTestSelected.value === true) {
      params.push(
        {
          key: 'debug', value: '123'
        }
      );
    }
    return this.usersListService.generateLoginAsUrl(userToken, params, null, v2);
  }


  ngOnInit(): void {
  }

  publicationChanged(e: ISelectedPublicationEvent) {
    this.selectedPublication = e.selectedItem.uuid;
  }

}
